<template>
  <div id="app">
    <div :class="{loaded: !preloaderVisible}" class="preloader">
      <img class="logo" src="./assets/images/animated_logo.gif" alt="logo">
    </div>
    <header :class="{loaded: !preloaderVisible, light: lightHeader, opened: headerOpened}" class="header" ref="header">
      <div class="header-container">
        <div class="logo anim-opacity">
          <img src="./assets/images/logo.png" alt="logo"/>
          <img class="black" src="./assets/images/logo_black.png" alt="logo"/>
        </div>
        <span class="separator w-100 anim-ltr"></span>
        <navigation :vertical="headerVertical" :items="navigationItems"/>
        <span class="separator fill anim-ltr"></span>
        <div class="social">
          <a class="anim-opacity" :href="$settings.get('Facebook')">
            <svg class="facebook" version="1.1" xmlns="http://www.w3.org/2000/svg"
                 viewBox="-994 991 10 20" xml:space="preserve">
<path d="M-987.6,997.2v-1.5c0-0.7,0.5-0.9,0.8-0.9c0.3,0,2.1,0,2.1,0v-3.3l-3,0c-3.3,0-4,2.4-4,4v1.7
h-1.9v3.8h1.9c0,4.3,0,9.6,0,9.6h3.8c0,0,0-5.3,0-9.6h2.8l0.3-3.8H-987.6z"></path>
</svg>
          </a>
          <a class="anim-opacity" :href="$settings.get('Intsagram')">
            <svg class="instagram" version="1.1" xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 512 512" xml:space="preserve">
              <path
                d="M352,0H160C71.648,0,0,71.648,0,160v192c0,88.352,71.648,160,160,160h192c88.352,0,160-71.648,160-160V160 C512,71.648,440.352,0,352,0z M464,352c0,61.76-50.24,112-112,112H160c-61.76,0-112-50.24-112-112V160C48,98.24,98.24,48,160,48 h192c61.76,0,112,50.24,112,112V352z"></path>
              <path
                d="M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128S326.688,128,256,128z M256,336 c-44.096,0-80-35.904-80-80c0-44.128,35.904-80,80-80s80,35.872,80,80C336,300.096,300.096,336,256,336z"></path>
              <circle cx="393.6" cy="118.4" r="17.056"></circle>
            </svg>
          </a>
          <a class="anim-opacity" :href="$settings.get('Twitter')">
            <svg class="twitter" version="1.1" xmlns="http://www.w3.org/2000/svg"
                 viewBox="-991 991 17 20" xml:space="preserve">
            <path d="M-975.7,997c-0.5,0.2-1,0.3-1.5,0.4c0.6-0.3,1-0.8,1.2-1.4c0,0,0-0.1-0.1-0.1
              c-0.5,0.3-1.1,0.5-1.7,0.6c-0.5-0.5-1.2-0.9-2.1-0.9c-1.6,0-2.8,1.2-2.8,2.8c0,0.2,0,0.4,0.1,0.6c-2.3-0.1-4.4-1.2-5.8-2.9
              c0,0,0,0,0,0c-0.2,0.4-0.4,0.9-0.4,1.4c0,0.9,0.5,1.8,1.2,2.3c0,0,0,0,0,0c-0.4,0-0.8-0.1-1.2-0.3c0,0,0,0,0,0c0,0.1,0,0.7,0.2,1
              c0.4,0.9,1.1,1.5,2.1,1.7c-0.2,0.1-0.5,0.1-0.7,0.1c-0.2,0-0.3,0-0.5,0c0,0,0,0,0,0c0.4,1.1,1.4,1.9,2.6,1.9c0,0,0,0,0,0
              c-1,0.7-2.2,1.2-3.5,1.2c-0.2,0-0.5,0-0.7,0c1.3,0.8,2.7,1.2,4.3,1.2c2.2,0,4-0.8,5.3-1.9c1.3-1.2,2.2-2.7,2.6-4.3
              c0.1-0.6,0.2-1.1,0.2-1.7c0-0.1,0-0.2,0-0.4C-976.5,998-976,997.6-975.7,997C-975.6,997-975.7,997-975.7,997z"></path>
            </svg>
          </a>
          <a class="anim-opacity" :href="$settings.get('LinkedIn')">
            <svg class="linkedin" version="1.1" xmlns="http://www.w3.org/2000/svg"
                 x="0px" y="0px"
                 width="430.117px" height="430.117px" viewBox="0 0 430.117 430.117"
                 xml:space="preserve">
<path d="M430.117,261.543V420.56h-92.188V272.193c0-37.271-13.334-62.707-46.703-62.707
		c-25.473,0-40.632,17.142-47.301,33.724c-2.432,5.928-3.058,14.179-3.058,22.477V420.56h-92.219c0,0,1.242-251.285,0-277.32h92.21
		v39.309c-0.187,0.294-0.43,0.611-0.606,0.896h0.606v-0.896c12.251-18.869,34.13-45.824,83.102-45.824
		C384.633,136.724,430.117,176.361,430.117,261.543z M52.183,9.558C20.635,9.558,0,30.251,0,57.463
		c0,26.619,20.038,47.94,50.959,47.94h0.616c32.159,0,52.159-21.317,52.159-47.94C103.128,30.251,83.734,9.558,52.183,9.558z
		 M5.477,420.56h92.184v-277.32H5.477V420.56z"></path>
</svg>
          </a>
          <a v-if="!!languageToSelect" class="anim-opacity"
             @click="selectLanguage(languageToSelect.short)">
            <img class="language-flag" :src="languageToSelect.image" :alt="languageToSelect.name"/>
          </a>
        </div>
        <span class="separator w-100 anim-rtl"></span>
        <div class="mobile-header-toggle" @click="toggleHeaderMenu">
          <div class="line-1"></div>
          <div class="line-2"></div>
        </div>
      </div>
    </header>
    <transition name="reveal" mode="out-in" appear @before-enter="animationEnd"
                @before-leave="revertSettings" :class="{'reveal-leave-active': true}">
      <router-view v-if="!preloaderVisible" :class="{loaded: !animationInProgress}" @header-color="changeHeaderColor"
                   @scrollbar-visibility="changeScrollbarVisibility" :articles="routeArticles"/>
    </transition>
  </div>
</template>

<script>
  import Navigation from "@/components/Navigation";

  const axios = require('axios');
  export default {
    name: "App",
    metaInfo: {
      title: "Wagner-Hatfield",
      titleTemplate: '%s | Wagner-Hatfield',
      meta: [
        {charset: 'utf-8'},
        {
          property: 'og:site_name',
          content: "Wagner-Hatfield"
        }
      ]
    },
    components: {Navigation},
    data: () => ({
      preloaderVisible: true,
      animationInProgress: true,
      navigationItems: [],
      lightHeader: false,
      headerOpened: false,
      headerVertical: false,
      scrollbarVisible: true,
      languageMenuOpen: false,
      dataFetched: false,
      dataFetchedCallback: null,
      selectedLanguage: window.localStorage.getItem("language") || 'en',
      languageToSelect: {},
      articles: [],
      routeArticles: []
    }),
    computed: {},
    watch: {
      headerOpened: function (value) {
        this.scrollbarVisible = !value;
      },
      scrollbarVisible: function (value) {
        document.documentElement.style.overflowY = value ? "scroll" : "hidden";
      },
      articles: function () {
        this.routeArticles = this.getArticlesByRoute(this.$route.name)
      },
      '$route': function (value) {
        this.routeArticles = this.getArticlesByRoute(value.name)
      }
    },
    methods: {
      animationStart: function () {
        this.animationInProgress = true;
      },
      animationEnd: function () {
        this.animationInProgress = false;
        this.headerOpened = false;
      },
      getArticlesByRoute: function (route) {
        switch (route) {
          case "news":
            return this.articles.filter(function (item) {
              return item.News === "1" && item.Static === "0"
            });
          case "www":
            return this.articles.filter(function (item) {
              return item.News === "0" && item.Static === "1"
            });
        }
      },
      revertSettings: function () {
        this.animationStart();
        if (this.lightHeader) {
          this.lightHeader = false;
        }
        if (!this.scrollbarVisible) {
          this.scrollbarVisible = true;
        }
      },
      changeHeaderColor: function (isLight) {
        this.lightHeader = isLight;
      },
      changeScrollbarVisibility: function (isVisible) {
        this.scrollbarVisible = isVisible;
      },
      toggleLanguageMenu: function () {
        this.languageMenuOpen = !this.languageMenuOpen;
      },
      toggleHeaderMenu: function () {
        this.headerOpened = !this.headerOpened;
      },
      selectLanguage: function (language) {
        window.localStorage.setItem("language", language);
        window.location.reload();
      }
    },
    created: function () {
      if (this.selectedLanguage === "en") {
        this.languageToSelect = {
          short: 'fr',
          name: "French",
          image: require("./assets/images/flag_fr.svg")
        }
      } else {
        this.languageToSelect = {
          short: 'en',
          name: "English",
          image: require("./assets/images/flag_uk.svg")
        }
      }
      this.$api.onLoad(() => {
        this.articles = this.$articles.all();
        this.navigationItems = [
          {
            path: '/home',
            text: this.$translations.get("header_home")
          },
          {
            path: '/bodies',
            text: this.$translations.get("header_bodies")
          },
          {
            path: '/where-we-work',
            text: this.$translations.get("header_where_we_work")
          },
          {
            path: '/contact',
            text: this.$translations.get("header_contact")
          },
          {
            path: '/news',
            text: this.$translations.get("header_news")
          },
          {
            path: '/about',
            text: this.$translations.get("header_about")
          }
        ];
        setTimeout(() => {
          this.preloaderVisible = false;
        }, 2000);
      });
      this.$router.beforeEach((to, from, next) => {
        if (this.animationInProgress) {
          next(false)
        } else {
          if (to.name !== from.name) {
            this.$refs["header"].scrollIntoView({behavior: 'smooth'});
          }
          next()
        }
      });
    },
    mounted: function () {
      window.addEventListener("resize", () => {
        this.headerVertical = window.innerWidth <= 800;
      });
      window.dispatchEvent(new Event('resize'));
    }
  }
</script>

<style lang="scss">
  @import "static/css/fonts.css";
  @import "static/css/style";

  .reveal-leave-active {

    &::after {
      opacity: 1 !important;
      transform-origin: center top !important;
      @include animation(heightStretch 500ms $default-ease 0ms 1 both);
    }
  }

  .reveal-enter-active {

    &::after {
      opacity: 1 !important;
      @include animation(heightCollapse 500ms $default-ease 0ms 1 both);
    }
  }
</style>
